<template>
  <v-data-table
    data-app
    class="tabela-justificativas"
    :items="formattedItems"
    :headers="headers"
    :items-per-page="-1"
    hide-default-footer
  >
    <template v-slot:item="{ item }">
      <tr class="table-v-tr" :class="{ 'row-erro': errosItem(item).length }" style="cursor: default">
        <td
          v-for="col in headers"
          :key="col.value"
          :class="{ nowrap: col.nowrap, 'col-fixa': col.fixa }"
          :style="{ 'text-align': col.textAlign }"
        >
          <div
            v-if="col.value === 'descricao'"
            class="d-flex text-truncate"
            style="min-width: 250px"
            :title="item.descricao"
          >
            <v-tooltip bottom v-if="errosItem(item).length">
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-on="on"
                  v-bind="attrs"
                  class="indicador-erro"
                  data-testid="indicador-erro-linha"
                ></div>
              </template>
              <div v-for="(erro, i) in errosItem(item)" :key="i">{{ erro }}</div>
            </v-tooltip>
            <span>{{ item.descricao }}</span>
          </div>

          <v-btn
            v-else-if="col.value === 'notas'"
            color="primary"
            icon
            @click="$emit('open-notas', item.notas, item)"
          >
            <v-icon large>mdi-card-search</v-icon>
          </v-btn>

          <div
            v-else-if="col.value === 'justificativa'"
            :title="item.justificativa"
            @click="$emit('edit', item)"
          >
            <div class="d-flex">
              <div class="cursor-pointer text-truncate" style="max-width: 300px">
                {{ item.justificativa || "Nenhuma justificativa." }}
              </div>
            </div>
            <div
              v-if="item.justificativa && item.justificativa.length > 3000"
              style="color: red; font-size: 10px"
            >
              Texto de justificativa ultrapassou o limite de caracteres.
            </div>
            <div
              v-else-if="!item.justificativa || item.justificativa.length == 0"
              style="color: red; font-size: 10px"
            >
              Texto de justificativa é obrigatório.
            </div>
          </div>

          <div
            v-else-if="col.value === 'funcao_projeto'"
            class="cursor-pointer text-truncate"
            style="max-width: 300px"
            :title="item.funcao_projeto"
            @click="$emit('edit', item)"
          >
            <div class="d-flex">
              {{ item.funcao_projeto || "Nenhuma descrição do agrupamento." }}
            </div>
            <div
              v-if="item.funcao_projeto && item.funcao_projeto.length > 100"
              style="color: red; font-size: 10px"
            >
              Texto de agrupamento ultrapassou o limite.
            </div>
            <div
              v-else-if="!item.funcao_projeto || item.funcao_projeto.length == 0"
              style="color: red; font-size: 10px"
            >
              Texto de agrupamento é obrigatório.
            </div>
          </div>

          <template v-else>
            {{ col.format ? col.format(item[col.value]) : item[col.value] }}
          </template>
        </td>
      </tr>
    </template>
    <template v-slot:[`body.append`]="append" v-if="projetoWrapper.total">
      <tr class="table-v-tr">
        <th
          style="cursor: default; font-size: 13px !important"
          v-for="col in append.headers"
          :key="col.value"
          :class="{ nowrap: col.nowrap, 'col-fixa': col.fixa }"
          :style="{ 'text-align': col.textAlign }"
        >
          {{ col.format ? col.format(projetoWrapper.total[col.value]) : projetoWrapper.total[col.value] }}
        </th>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { getErrosMaterial } from "@/core/utils/validacoesJustificativas";

export default {
  name: "TableMateriaisLB",
  props: {
    projetoWrapper: {
      type: Object,
      required: true,
    },
    trabalho: {
      type: Number,
      required: true,
    },
    somenteErros: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    errosItem(item) {
      return getErrosMaterial(item, this.trabalho);
    },
  },
  computed: {
    formattedItems() {
      const itens = this.projetoWrapper.materiais || [];
      if (this.somenteErros) {
        return itens.filter((item) => this.errosItem(item).length);
      }
      return itens;
    },
    headers() {
      return [
        {
          text: "Agrupamento",
          value: "descricao",
          fixa: true,
          class: "col-fixa",
        },
        {
          text: "Valor (R$)",
          value: "valor",
          textAlign: "right",
          align: "right",
          format: (value) => {
            if (value || value == 0) {
              return parseFloat(value).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            }
            return "";
          },
        },
        {
          text: "Descrição do Agrupamento",
          value: "funcao_projeto",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        {
          text: "",
          value: "notas",
          width: "14%",
        },
      ];
    },
  },
};
</script>

<style scoped>
.table-v-tr:hover {
  background-color: #f5f5f5;
}
.row-erro {
  background-color: #fff5f5;
}
.indicador-erro {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 100%;
  margin-right: 5px;
  margin-top: 4px;
  flex-shrink: 0;
}
.cursor-pointer {
  cursor: pointer;
}
.nowrap {
  white-space: nowrap;
}
</style>
